module.exports = __webpack_public_path__ + "static/media/black-lives-matter.9156053d.svg";